import { SharedOrderLeisureQuery } from '~/__generated__/app/query/order-shared/order-shared-leisure.graphql'

type SharedOrder = SharedOrderLeisureQuery['sharedOrder']

export const getAllCategoryOrders = (sharedOrder?: SharedOrder) => [
  ...(sharedOrder?.categoryOrders ?? []),
  ...(sharedOrder?.additionalCategoryOrders ?? []),
]
